import config from 'config/config'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setTab } from 'redux/tabs'
import { Menu, Segment } from 'semantic-ui-react'
import TabContent from './TabContent'

const mapStateToProps = (state, ownProps) => {
  const activeTab = state.tabs[ownProps.context]
  return { activeTab }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      setTab,
    },
    dispatch
  )
}

class Tabs extends React.Component {
  // LOL: 0.70 just brought us tabs: https://react.semantic-ui.com/modules/tab

  componentWillMount() {
    const { startTab, tabs, context, setTab } = this.props
    if (startTab && tabs.find((tab) => tab.key === startTab))
      setTab(context, startTab)
    else setTab(context, tabs[0].key)
  }

  componentWillReceiveProps(nextProps) {
    const { activeTab, tabs, context, setTab } = nextProps
    if (!tabs.find((tab) => tab.key === activeTab)) {
      setTab(context, tabs[0].key)
    }
  }

  getMenuItems() {
    const { tabs, activeTab, context } = this.props
    const { setTab } = this.props

    return tabs.map((tab, index) => (
      <Menu.Item
        key={tab.key}
        content={tab.title}
        active={activeTab === tab.key}
        onClick={() => setTab(context, tab.key)}
      />
    ))
  }

  getTabContent() {
    const { tabs, context } = this.props
    return tabs.map((tab, index) => (
      <TabContent
        key={tab.key}
        content={tab.key}
        open={tab.open}
        children={tab.content}
        context={context}
      />
    ))
  }

  render() {
    const dark = config.theme.dark
    // props
    const { disabled } = this.props

    return (
      <div>
        <Segment
          attached
          className={classNames(['tab-control', dark && 'inverted'])}
          disabled={disabled}>
          <Menu
            compact
            className="tab-control-menu"
            inverted={dark}
            color={dark ? undefined : config.semantic_ui.primary_color}
            secondary={!dark}
            pointing={!dark}
            children={this.getMenuItems()}
            size="large"
          />
        </Segment>

        {this.getTabContent()}
      </div>
    )
  }
}

Tabs = connect(mapStateToProps, mapDispatchToProps)(Tabs)
export default Tabs



// WEBPACK FOOTER //
// ./src/components/admin/Helper/Tabs.jsx